import { makeGetRequest } from 'owa-ows-gateway';

const GET_WEB_PUSH_SUBSCRIPTIONS_URL: string = 'ows/beta/webpushsubscriptions';

export default async function loadWebPushSubscriptions(): Promise<OwaPushSubscription[]> {
    return makeGetRequest(GET_WEB_PUSH_SUBSCRIPTIONS_URL).then(function(
        response: PushSubscriptionsResponse
    ) {
        if (response.subscriptions) {
            return response.subscriptions;
        } else {
            throw new Error('Failed to load web push subscriptions');
        }
    });
}
